import React from "react";
import { PrimaryButton } from "../buttons/primaryButton";

const LoginButton = ({ buttonName, color, padding, rounded, type }) => {
  return (
    <PrimaryButton
      buttonName={buttonName}
      color={color}
      padding={padding}
      rounded={rounded}
      type={type}
    />
  );
};

export default LoginButton;
